import TimeOfDay from './TimeOfDay';
import DayOfWeek from './DayOfWeek';

const RIGHT_OPERAND = {
  timeOfDay: TimeOfDay,
  dayOfWeek: DayOfWeek
};

export default RIGHT_OPERAND;
